import React, { Component } from 'react';
import cx from "classnames";

const MODERN_PALETTE = [
    { bg: '#E3F2FD', text: '#1565C0' }, // Blue
    { bg: '#E8F5E9', text: '#2E7D32' }, // Green
    { bg: '#F3E5F5', text: '#7B1FA2' }, // Purple
    { bg: '#FFF3E0', text: '#EF6C00' }, // Orange
    { bg: '#FFEBEE', text: '#C62828' }, // Red
    { bg: '#E0F2F1', text: '#00695C' }, // Teal
    { bg: '#F9FBE7', text: '#827717' }, // Lime
    { bg: '#FCE4EC', text: '#C2185B' }, // Pink
];

export default class ItemTag extends Component {
    constructor(props) {
        super(props);
    }

    getColor(id) {
        // Simple hash logic to pick a color
        const index = id % MODERN_PALETTE.length;
        return MODERN_PALETTE[index];
    }

    handleClick = (tag) => {
        if (tag.parent_id == 0) {
            this.props.handleParent(tag.tag_id);
        } else if (this.props.handleUpdateTag) {
            this.props.handleUpdateTag({
                tag: tag,
                contact: this.props.contactInfoSelected
            })
        }
    }
    render() {
        const colorTheme = this.getColor(this.props.tag.tag_id || 0);

        const activeStyle = {
            backgroundColor: colorTheme.bg,
            color: colorTheme.text,
            border: `1px solid ${colorTheme.bg}`
        };

        return (
            <div
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleClick(this.props.tag)
                }}
                className={cx('item-tag-modern', this.props.active ? "active" : "")}
                style={this.props.active ? activeStyle : {}}
            >
                {this.props.tag.tag_name}
            </div>
        )
    }
}
